import { FilterHandler, useFilterState } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import ConfigsLoader, { useConfig } from '../_load/ConfigsLoader'
import Form from '../../../packages/kiti/components/form/form/Form'
import Line from '../../../packages/kiti/components/helpers/Line'
import Modal from '../../../components/structure/Modal'
import ModalPickerFooter from '../../../components/form/modalPicker/ModalPickerFooter'
import ModalPickerHeader from '../../../components/form/modalPicker/ModalPickerHeader'
import Picker from '../../../packages/kiti/components/form/picker/Picker'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import SelectableListItem from '../../../packages/kiti/components/list/SelectableListItem'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const Footer = ({ onClose, onChange, filter }) => {
  return <ModalPickerFooter closeModal={onClose} onChange={onChange}></ModalPickerFooter>
}

const Content = ({ configName, ...props }) => {
  const config = useConfig(configName)
  const { t } = useTranslation('common')
  let options = config?.value || []
  if (configName === 'service_order_started_since_colors') {
    options = options.map(option => ({ ...option, label: t('config.service_order_started_since_colors.' + option.id) }))
  }

  const { form, handleChangeIn } = useFormState()

  return (
    <Picker
      Selector={SelectableListItem}
      options={options}
      value={form || []}
      onChange={handleChangeIn([])}
      idField="id"
      labelField="label"
      {...props}
    />
  )
}

const ConfigValuePickerModal = ({ open, onClose, value, onChange, level, ...props }) => {
  const { t } = useTranslation('serviceOrders')
  return (
    <Modal width="42rem" noPadding open={open} onClose={() => onClose()} level={level}>
      <FilterHandler>
        <Form initialState={value || []}>
          <ModalPickerHeader title={t('filters.selectSemaphore')} {...props} />
          <Line />

          <Scroll height="65vh">
            <ConfigsLoader translate>
              <Content closeModal={onClose} {...props} />
            </ConfigsLoader>
            <Separator weight={12} />
          </Scroll>

          <Line />
          <Footer onClose={onClose} onChange={onChange} {...props} />
        </Form>
      </FilterHandler>
    </Modal>
  )
}

export default ConfigValuePickerModal
